import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Loader2, CheckCircle2, Mail } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export const UnsubscribePage = () => {
  const { token } = useParams();
  const [state, setState] = useState('loading'); // loading | ready | done | invalid
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let mounted = true;
    axios.get(`${API}/email/unsubscribe/${token}`)
      .then((r) => {
        if (!mounted) return;
        setEmail(r.data?.email_masked || '');
        setState(r.data?.status === 'unsubscribed' ? 'done' : 'ready');
      })
      .catch(() => { if (mounted) setState('invalid'); });
    return () => { mounted = false; };
  }, [token]);

  const confirm = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/email/unsubscribe/${token}/confirm`);
      setState('done');
    } catch {
      setState('invalid');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-zinc-200 p-8 text-center" data-testid="unsubscribe-card">
        <div className="w-12 h-12 rounded-xl bg-indigo-600 text-white flex items-center justify-center mx-auto mb-5">
          <Mail className="w-6 h-6" />
        </div>
        {state === 'loading' && <Loader2 className="w-6 h-6 animate-spin text-indigo-600 mx-auto" />}

        {state === 'ready' && (
          <>
            <h1 className="text-xl font-bold text-zinc-900 mb-2">Unsubscribe?</h1>
            <p className="text-sm text-zinc-600 mb-6">You're about to stop receiving emails sent to <span className="font-medium">{email}</span>.</p>
            <button onClick={confirm} disabled={busy} className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-2.5 rounded-lg transition-colors inline-flex items-center justify-center" data-testid="confirm-unsubscribe-btn">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Unsubscribe me'}
            </button>
          </>
        )}

        {state === 'done' && (
          <>
            <CheckCircle2 className="w-10 h-10 text-emerald-500 mx-auto mb-3" />
            <h1 className="text-xl font-bold text-zinc-900 mb-2">You're unsubscribed</h1>
            <p className="text-sm text-zinc-600">{email && <>{email} </>}won't receive any more emails from this sender. Sorry to see you go.</p>
          </>
        )}

        {state === 'invalid' && (
          <>
            <h1 className="text-xl font-bold text-zinc-900 mb-2">Link not found</h1>
            <p className="text-sm text-zinc-600">This unsubscribe link is invalid or has already been used.</p>
          </>
        )}
      </div>
    </div>
  );
};

export default UnsubscribePage;
